import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Wrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 20px;
  border-bottom: 1px solid hsla(0, 0%, 0%, 0.08);

  ${media.mobile} {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Tab = styled.button<{ $active?: boolean; $accentColor: string }>`
  padding: 10px 16px;
  font-size: 14px;
  line-height: 20px;
  font-weight: ${({ $active }) => ($active ? 500 : 400)};
  color: ${({ $active, $accentColor, theme }) =>
    $active ? $accentColor : theme.colors['neutral-70']};
  background: none;
  border: none;
  border-bottom: 2px solid
    ${({ $active, $accentColor }) => ($active ? $accentColor : 'transparent')};
  margin-bottom: -1px;
  cursor: pointer;
  transition: color 200ms cubic-bezier(0.2, 0.8, 0.4, 1), border-color 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  white-space: nowrap;
  min-height: 40px;
  border-radius: 8px 8px 0 0;
  -webkit-tap-highlight-color: transparent;
  flex-shrink: 0;

  &:hover {
    color: ${({ $accentColor }) => $accentColor};
    background-color: ${({ theme }) => theme.colors['neutral-10']};
  }

  ${media.mobile} {
    padding: 10px 12px;
    font-size: 13px;
    min-height: 44px;
  }
`;

export const Count = styled.span`
  margin-left: 4px;
  opacity: 0.7;
`;
